import React from "react";

import type { SubCategoryFaqItem } from "../types";

interface SubCategoryFaqSectionProps {
    titleHighlight: string;
    items: readonly SubCategoryFaqItem[];
    faqTitleSuffix: string;
}

const SubCategoryFaqSection: React.FC<SubCategoryFaqSectionProps> = ({ titleHighlight, items, faqTitleSuffix }) => (
    <section className="bg-muted/50">
        <div className="mx-auto w-full max-w-3xl px-4 py-12 text-center sm:px-6 sm:py-14 lg:py-16">
            <h2 className="text-2xl font-black leading-tight tracking-tight sm:text-3xl lg:text-4xl">
                <span className="text-primary">{titleHighlight}</span>
                <span className="text-foreground">{faqTitleSuffix}</span>
            </h2>

            <div className="mx-auto mt-10 max-w-2xl space-y-10 text-left sm:mt-12">
                {items.map((item) => (
                    <article key={item.question} className="space-y-3">
                        <h3 className="text-base font-bold leading-snug text-foreground sm:text-lg">{item.question}</h3>
                        <p className="text-sm leading-relaxed text-muted-foreground sm:text-base">{item.answer}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);

export default SubCategoryFaqSection;
